import { useState } from "react";
import { observer } from "mobx-react";
import TextBlock from "components/UI/TextBlock/TextBlock";
import { useMatchMedia } from "utils/hooks/use-match-media";
import "./SettingsSeoAIQuestion.scss";

const MAX_QUESTIONS = 10;

const SettingsSeoAIQuestion = observer(({ store, questionRef }) => {
    const { isMobile } = useMatchMedia();
    const [draft, setDraft] = useState("");

    const addQuestion = () => {
        if (!draft.trim() || store.aiQuestions.length >= MAX_QUESTIONS) return;
        store.addAiQuestion(draft);
        setDraft("");
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            addQuestion();
        }
    };

    return (
        <div className="settings-seo-ai-question__container">
            <div
                className="settings-seo-ai-question__container-input"
                ref={questionRef}
            >
                <div className="settings-seo-step__title">
                    <TextBlock
                        title="Введите вопросы, которые нужно задать"
                        titleClassName="settings-seo-step__label"
                    />

                    {!isMobile && (
                        <TextBlock
                            title="Эти вопросы будут отправлены в выбранную AI-платформу"
                            titleClassName="settings-seo-step__sublabel"
                        />
                    )}
                </div>

                <div className="settings-seo-ai-question__input-row">
                    <textarea
                        className={`settings-seo-ai-question__textarea ${
                            store.aiQuestionError ? "error" : ""
                        }`}
                        value={draft}
                        onChange={(e) => setDraft(e.target.value)}
                        onKeyDown={onKeyDown}
                        placeholder="Например: какие лучшие CRM для малого бизнеса"
                        disabled={store.aiQuestions.length >= MAX_QUESTIONS}
                    />
                    <button
                        className={`settings-seo-ai-question__add-btn ${
                            !draft.trim() || store.aiQuestions.length >= MAX_QUESTIONS ? "disabled" : ""
                        }`}
                        onClick={addQuestion}
                        type="button"
                    />
                </div>

                {store.aiQuestionError && (
                    <p className="settings-seo-ai-question__error">{store.aiQuestionError}</p>
                )}

                {store.aiQuestions.length > 0 && (
                    <div className="settings-seo-ai-question__tags">
                        {store.aiQuestions.map((q, i) => (
                            <div key={i} className="settings-seo-ai-question__tag">
                                <span className="settings-seo-ai-question__tag-text">{q}</span>
                                <button
                                    className="settings-seo-ai-question__tag-remove"
                                    onClick={() => store.removeAiQuestion(q)}
                                    type="button"
                                />
                            </div>
                        ))}
                    </div>
                )}

                <div className="settings-seo-ai-question__count">
                    <p>{store.aiQuestions.length}<span>/{MAX_QUESTIONS}</span></p>
                </div>
            </div>
        </div>
    );
});

export default SettingsSeoAIQuestion;
